module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Frontmatter03#sec1"
    }
  }, [_c('i', [_vm._v("A Personal Note / Tim Robinson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Acknowledgments#sec2"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Frontmatter04#sec3"
    }
  }, [_c('i', [_vm._v("Nomenclature")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Frontmatter05#sec4"
    }
  }, [_c('i', [_vm._v("Reading This Volume")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Prologue#sec5"
    }
  }, [_c('i', [_vm._v("Prologue")]), _vm._v(": Space, Time & Connemara / Tim Robinson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmb",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Frontmatter06#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Conamara Chronicles")]), _vm._v(": An Introductory Note / Liam Mac Con Iomaire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter01#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Holy Men and the Islands")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Troubled Times")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter03#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Year of the French (1798)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter04#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Tories/Vigilantes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter05#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Big Men")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter06#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Robbers and Treasures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter07#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Smugglers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter08#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Poor Scholars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter09#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Priests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter10#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "spacec1"
  }, [_vm._v("People and Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter11#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "spacec1"
  }, [_vm._v("Boatmen and Timber")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter12#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "spacec1"
  }, [_vm._v("Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter13#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "spacec1"
  }, [_vm._v("Wisps of Straw")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter14#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "spacec1"
  }, [_vm._v("Custodians of Traditional Lore and Storytellers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmt",
    attrs: {
      "id": "rsec21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Chapter15#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('i', [_vm._v("Meet the Storytellers / Liam Mac Con Iomaire")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Bibliography#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Maps#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Back01#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Author Biographies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063526_Index#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Placename Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5407c6ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253063526_Contents.vue
// module id = 75
// module chunks = 0